<template>
  <div class="limiter" v-if="id">
    <div class="image">
      <img src="../assets/logo/logo.png" alt="Logo">
    </div>
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="container">
          <!-- Display username -->
          <div v-if="username" class="username-display">
            <p>Welcome, {{ username }}! </p>
            <p>Current state: {{ state }}</p>
          </div>
          <div class="static-text">HOW IS THE STOCK MOVING?</div>


          <div class="card-container">
            <!-- Show Picking card when state is 'new' -->
            <div v-if="state === 'NEW'" class="card" @click="confirmAndUpdateState('PICKED', 'Has the stock been picked?', 'Picked')">
              <div class="card-content">
                <i class="fa-solid fa-cubes icon-size icon-color"></i>
              </div>
              <div class="card-footer">
                <p>Pick Item</p>
              </div>
            </div>

            <!-- Show YANGO card when state is 'picked' -->
            <div v-if="state === 'PICKED'" class="card" @click="yango">
              <div class="card-content">
                <div class="image1">
                  <img src="../assets/img/Yango.png" alt="delivered by one of our staff">
                </div>
              </div>
              <div class="card-footer">
                <p>YANGO DELIVERY</p>
              </div>
            </div>

            <!-- Show STAFF card when state is 'transit' or 'picked' -->
            <div v-if="state === 'PICKED' || state === 'TRANSIT'" class="card" @click="confirmAndUpdateState('OFFICE', 'Has the stock arrived at the office?', 'Office')">
              <div class="card-content">
                <div class="image1">
                  <img src="../assets/img/Office.png" alt="delivered by one of our staff">
                </div>
              </div>
              <div class="card-footer">
                <p>OFFICE</p>
              </div>
            </div>

            <!-- To site card when state is 'ready' -->
            <div v-if="state === 'OFFICE'" class="card" @click="confirmAndUpdateState('TO_SITE','Is the stock with the technician?', 'Ready To Install')">
              <div class="card-content">
                <div class="image1">
                  <img src="../assets/img/Tech.png" alt="delivered by one of our staff">
                </div>
              </div>
              <div class="card-footer">
                <p class="text">To site</p>
              </div>
            </div>

            <!-- To site card when state is 'ready' -->
            <div v-if="state === 'TO_SITE'" class="card" @click="completed">
              <div class="card-content">
                <div class="image1">
                  <i class="fa-solid fa-cubes icon-size icon-color"></i>
                </div>
              </div>
              <div class="card-footer">
                <p class="text">Completed</p>
              </div>
            </div>

            <!-- Show stock card when state is 'tosite' -->
            <div v-if="state === 'TO_SITE' || state === 'COMPLETED'" class="card" @click="showStock">
              <div class="card-content">
                <div class="image1">
                  <img src="../assets/img/Tech.png" alt="delivered by one of our staff">
                </div>
              </div>
              <div class="card-footer">
                <p>Show Stock</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default  {
  name: 'DispatchPage',
  data() {
    return {
      id: this.$route.query.id,
      state: '',
      status: '',
      Delivered: this.$route.query.Delivered,
      username: this.$route.query.userName
    };
  },
  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
    '$route.query.userName': function(newUserName) {
      this.username = newUserName;
    }
  },
  created() {
    this.fetchInitialState();
  },
  methods: {
    async yango(){
      this.$router.push({ name: 'Yango', query: { id: this.id, userName: this.username} });
    },

    async fetchInitialState() {
      this.$store.commit('setLoadingState', true);
      const payload = {
        urlId: this.$route.query.urlId,
        id: this.id
      }
      return this.$store.dispatch('fetchInitialState',payload)
          .then((response) => this.state = response.type)
          .finally(()=> this.$store.commit('setLoadingState', false))
    },

    async confirmAndUpdateState(newState, label, status) {
      const result = await Swal.fire({
        title: label,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      });

      if (result.isConfirmed) {
        await this.updateState(newState,status);
      }
    },

    async updateState(newState, status) {
      const payload = {
        dispId: this.id,
        username: this.username,
        type: newState,
        status: status
      };
      this.$store.commit('setLoadingState', true);
      return await this.$store.dispatch('updateState', payload)
          .then(() => {
            responses.showSuccess('Successfully updated the state.')
            this.logout();
          })
          .finally(()=> this.$store.commit('setLoadingState', false))
    },

    logout() {
      localStorage.removeItem('user');
      this.$router.push(`/login?id=${this.id}`);
    },

    showStock() {
      this.$router.push({ name: 'ShowStock', query: {id: this.id, userName: this.username}});
    },

    async completed() {
      const payload = {
        dispatchId: Number(this.id),
        username: this.username,
      }
      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('sendOtp', payload)
          .then(()=> this.$router.push({ name: 'otpForm',query: { id: this.id} }))
          .finally(()=> this.$store.commit('setLoadingState', false))
    }
  }
}
</script>

<style scoped>

.container {
  text-align: center;
  padding: 20px;
}

.static-text {
  font-family: Poppins-Regular, sans-serif;
  font-weight: 600;
  width: 100%;
  font-size: clamp(1rem, 3vw, 3rem);
  margin-bottom: 20px;
  text-align: center;
  color: #666666;
}
@keyframes scroll {
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
}

.card-container {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.card {
  --font-color: #323232;
  --font-color-sub: #666;
  --bg-color: #fff;
  --main-color: #323232;
  --main-focus: #2d8cf0;
  width: 40vh;
  height: 50vh;
  border: 0.1px solid #424649;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  padding: 15px;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  cursor: pointer; /* Indicates the card is clickable */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3); /* Add a shadow effect */
}

.card:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2); /* Add a shadow effect */
  transform: translateY(-5px); /* Slightly lift the card */
}
/*.card:hover {*/
/*  transform: translateY(-20px);*/
/*  box-shadow: 4px 4px var(--main-color);*/
/*}*/

.card-content {
  flex: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-footer {
  flex: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #274261; /* Background color for the footer */
}

.card-footer p {
  color: #ffffff; /* White text color */
  font-weight: bold; /* Bold text */
  font-size: 1.25rem; /* Larger font size (adjust as needed) */
  margin: 0; /* Remove default margin */
}
.card-button {
  padding: 10px;
  margin-left: 10px;
  background-color: #3B3F42;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}

.card-button:hover {
  background-color: #101010;
  transform: scale(1.05);
}

.con {
  cursor: pointer;
  position: relative;
  padding: 10px 24px;
  font-size: 18px;
  letter-spacing: 1px;
  color: #0092F7;
  border: 2px solid #0092F7;
  border-radius: 10px;
  background-color: transparent;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.320, 1);
  overflow: hidden;
}

.con::before {
  content: '';
  position: absolute;
  inset: 0;
  margin: auto;
  width: 50px;
  height: 50px;
  border-radius: inherit;
  scale: 0;
  z-index: -1;
  background-color: #0092F7;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1);
}

.con:hover::before {
  scale: 3;
}

.con:hover {
  color: #212121;
  scale: 1.1;
  box-shadow: 0 0px 20px rgba(193, 163, 98,0.4);
}

.con:active {
  scale: 1;
}

@media (max-width: 768px) {
  .card-container {
    flex-direction: column;
    align-items: center;
  }

  .card {
    width: 35vh;
    height: 15vh;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .card-content, .card-footer {
    width: 55.5%;
    height: 99.9%;
    flex: none;
  }

  .card, .card-footer {
    padding: 0;
    padding-right: 20px;

  }
  .card, .card-footer {
    padding-left: 10px;

  }
  .card, .card-content {
    padding-left: 10px;

  }

  .card-content {
    order: 1;
  }
  .i {
    width: 90px;
    height: 70px;
    border-radius: 5px;
  }

  .ii {
    width: 58px;
    height: 58px;
  }

  .iii {
    width: 58px;
    height: 58px;
  }

  .card-footer {
    border-radius: 0px;
    order: 2;
  }
}

.wrap-login100 {
  min-width: 80%;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.icon-size {
  font-size: 5rem; /* Default size for small screens */
}

.icon-color {
  color: #0092F7; /* Set icon color */
}

.image1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image1 img {
  max-width: 70%;
  height: auto;
  display: block;
}
.icon-size {
  font-size: 5rem; /* Default size for small screens */
}

@media (min-width: 768px) {
  .icon-size {
    font-size: 10rem; /* Larger size for tablets and larger screens */
  }
}

@media (min-width: 1200px) {
  .icon-size {
    font-size: 10rem; /* Larger size for large screens */
  }
}
.icon-color {
  color: #1181A1; /* Set icon color */
}
</style>
